import { types } from "mobx-state-tree";
import Location from "./Location";

const LocationStore = types
  .model('LocationStore', {
    locations: types.optional(types.array(Location), []),
  })
  .actions((self) => ({
    setLocations(locations) {
      let newLocations = [];
      for (let i = 0; i < locations.length; i++) {
        newLocations.push(Location.create(locations[i]));
      }
      self.locations = [...newLocations];
    },
    addLocation(location) {
      self.locations.push(location);
    },
    editLocation(location) {
      const foundLocation = self.locations.find((loc) => loc.code === location.code);
      if(foundLocation) {
        foundLocation.description = location.description;
        foundLocation.phoneNumber = location.phoneNumber;
      }
    },
    deleteLocation(location) {
      const foundLocation = self.locations.find((loc) => loc.code === location.code);
      if(foundLocation) {
        self.locations.remove(foundLocation);
      }
    }
  }))
  .views((self) => ({
    get orderedLocations() {
      // sort alphabetically, copying the array first
      return self.locations.slice().sort(function (a, b) {
        return a.description.localeCompare(b.description);
      });
    },
  }));

export default LocationStore;
